import React from 'react';
import { FormattedMessage } from 'react-intl';

import Wrapper from './Wrapper';
import CustomSelect from 'Common/CustomSelect';

function MonthSelect(props) {
    const monthsList = () => {
        let months = [];
        for (let i = 1; i <= 12; i++) {
            months.push({ value: i, label: <FormattedMessage id={`types.month.${i}`} /> });
        }
        return months;
    };

    return <CustomSelect {...props} options={monthsList()} />;
}

export default function FormMonthSelect(props) {
    return <Wrapper {...props} InputComponent={MonthSelect} />;
}



// WEBPACK FOOTER //
// ./src/common/ReduxForm/FormMonthSelect.jsx